import loadingLogo from './loadingLogo.png'

export default loadingLogo
